import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {stringUtils} from 'front-onceforall-core';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';

function MessageView({document}) {
  return (
    <>
      <div>
        {stringUtils.getStrongs(I18n.t('notification.document.yourDocument', {
          documentName: document.type.name
        }))}
      </div>
      {document.certifyingThirdParty &&
        <div>({document.certifyingThirdParty})</div>
      }
      <div>
        <strong className="error">
          <Translate
            value={`dashboard.documentsToProcess.message.${document.state}`}
            expirationDate={I18n.l(document.validityEnd, {dateFormat: 'datetime.shortDate'})}
          />
        </strong>
      </div>
      {document.state === DOCUMENT_STATE.REJECTED && document.rejectionReason &&
        <div className="font-size-s">
          {document.rejectionReason}
        </div>
      }
    </>
  );
}

MessageView.propTypes = {
  document: PropTypes.object.isRequired
};

export default MessageView;
